import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CSSZSickLeaveCertificateEmploymentForm from './CSSZSickLeaveCertificateEmploymentForm';
import { Size } from '../../../../Enums/Size.enum';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import { CSSZSickLeaveValues } from '../CSSZSickLeaveCertificateCreate/CSSZSickLeaveCertificateCreate';
import { CSSZEmployment } from '../../Interfaces/CSSZ.interface';

interface Props extends BaseModalProps {
	patientId: string;
	collectedValues?: DeepPartial<CSSZSickLeaveValues>;
	onSubmit: (values: CSSZEmployment) => void;
}

const CSSZSickLeaveCertificateEmploymentFormModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.CSSZSickLeaveCertificateEmploymentForm.modalTitle'
			size={Size.LG}>
			<CSSZSickLeaveCertificateEmploymentForm
				onSubmit={props.onSubmit}
				patientId={props.patientId}
				collectedValues={props.collectedValues}
			/>
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateEmploymentFormModal;
